import { cn } from "@/lib/utils";
import { CourseMarkdown } from "@/components/storyboard/CourseMarkdown";
import type { ValidationResult } from "@/services/QuizValidationService";
import { getFeedbackDisplay } from "@/lib/validationSubmission";

export interface GradedFeedbackProps {
  result: ValidationResult;
  className?: string;
}

/**
 * Feedback box for LLM-graded validations: the four-level grade label as
 * heading, Markdown feedback below, tinted by grade (binary correct fallback).
 */
export const GradedFeedback = ({ result, className }: GradedFeedbackProps) => {
  const display = getFeedbackDisplay(result);
  return (
    <div className={cn("rounded-lg border p-3", display.className, className)}>
      <p className="mb-1 text-xs font-semibold uppercase tracking-wide">
        {display.label}
      </p>
      <div className="prose prose-sm max-w-full">
        <CourseMarkdown>{result.feedback}</CourseMarkdown>
      </div>
    </div>
  );
};
